import { handleActions } from "redux-actions";

import state from "./state";
export type PackagesState = typeof state;

const packages = handleActions({}, state);

export { packages };
